import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="exercise-autocomplete"
export default class extends Controller {
  static values = { options: Array }
  static targets = [ "input", "results" ]

  connect() {
    this.resultsTarget.hidden = true
  }

  filter(event) {
    const query = this.inputTarget.value.toLowerCase()
    const filteredOptions = this.optionsValue.filter(option =>
      option.toLowerCase().includes(query)
    )

    this.resultsTarget.innerHTML = ""
    if (query.length > 0 && filteredOptions.length > 0) {
      this.resultsTarget.hidden = false
      filteredOptions.forEach(option => {
        const li = document.createElement("li")
        li.textContent = option
        li.dataset.action = "click->exercise-autocomplete#select"
        this.resultsTarget.appendChild(li)
      })
    } else {
      this.resultsTarget.hidden = true
    }
  }

  select(event) {
    this.inputTarget.value = event.target.textContent
    this.resultsTarget.hidden = true
  }
}
